module.exports = __webpack_public_path__ + "002c3528498bb75303d5933ff7a212f7.jpg";


//////////////////
// WEBPACK FOOTER
// ../images/kitchens_thumb.jpg
// module id = 475
// module chunks = 0